// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3LThd","container":"styles_container__1p_Sp","title":"styles_title__1m05E","wrapper":"styles_wrapper__2x36D","answer":"styles_answer__1abTp"};